export default __webpack_public_path__ + "static/media/rail.13e4f80b.png";